var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoChannel16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 7.96721,
    height: 7.96721,
    rx: 1,
    fill: "#B1B1B1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 9.29507,
    width: 7.96721,
    height: 7.96721,
    rx: 1,
    fill: "#B1B1B1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 18.5902,
    width: 7.96721,
    height: 7.96721,
    rx: 1,
    fill: "#B1B1B1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 28.0328,
    width: 7.96721,
    height: 7.96721,
    rx: 1,
    fill: "#B1B1B1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 9.29517,
    width: 7.96721,
    height: 7.96721,
    rx: 1,
    fill: "#B1B1B1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 9.29517,
    y: 9.29507,
    width: 7.96721,
    height: 7.96721,
    rx: 1,
    fill: "#B1B1B1"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 9.29517,
    y: 18.5902,
    width: 7.96721,
    height: 7.96721,
    rx: 1,
    fill: "#B1B1B1"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 9.29517,
    y: 28.0328,
    width: 7.96721,
    height: 7.96721,
    rx: 1,
    fill: "#B1B1B1"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5901,
    width: 7.96721,
    height: 7.96721,
    rx: 1,
    fill: "#B1B1B1"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 28.0327,
    width: 7.96721,
    height: 7.96721,
    rx: 1,
    fill: "#B1B1B1"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5901,
    y: 9.29507,
    width: 7.96721,
    height: 7.96721,
    rx: 1,
    fill: "#B1B1B1"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 28.0327,
    y: 9.29507,
    width: 7.96721,
    height: 7.96721,
    rx: 1,
    fill: "#B1B1B1"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5901,
    y: 18.5902,
    width: 7.96721,
    height: 7.96721,
    rx: 1,
    fill: "#B1B1B1"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5901,
    y: 28.0328,
    width: 7.96721,
    height: 7.96721,
    rx: 1,
    fill: "#B1B1B1"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 28.0327,
    y: 18.5902,
    width: 7.96721,
    height: 7.96721,
    rx: 1,
    fill: "#B1B1B1"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 28.0327,
    y: 28.0328,
    width: 7.96721,
    height: 7.96721,
    rx: 1,
    fill: "#B1B1B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoChannel16);
export default __webpack_public_path__ + "static/media/ico-channel-16.facd48568ab27f83d97a6af455cf9943.svg";
export { ForwardRef as ReactComponent };